config.$inject = ["$stateProvider"];
export function config($stateProvider: ng.ui.IStateProvider): void {
    $stateProvider
    .state("login", {
        url: "/login",
        template: "<login-page></login-page>"
    })
    .state("register", {
        url: "/register",
        template: "<register-page></register-page>"
    })
    .state("password-reset", {
        url: "/password-reset",
        template: "<password-reset-page></password-reset-page>"
    })
    .state("profile", {
        url: "/profile",
        template: "<profile-page></profile-page>"
    })
    .state("forget-password", {
        url: "/forget-password",
        template: "<forget-password-page></forget-password-page>"
    })
    .state("migration", {
        url: "/migration",
        template: "<migration-page></migration-page>"
    });
}
